import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable()
export class AdminUsersHttp {
  constructor(protected httpService: HttpService) {}

  loadUsers = async () => await this.httpService.get('/customers?search=&skip=0');
  // search users
  getRoleWiseUsers = async ({ searchKey = '', roles = [], sort = 'id,desc', page = 0, size = 10 }) => {
    let params = { roles, page, size, searchKey, sort };
    return this.httpService.get(`/admin/users?&page=${page}&size=${size}&sort=${sort}&search=${searchKey}${roles && '&roles=' + roles}`);
  };

  filteredUserList = async (searchKey, listQuery) =>
    this.httpService.get(
      `/admin/users?&page=${listQuery.page}&size=${listQuery.size}${
        (listQuery.sortField && '&sort=' + listQuery.sortField) || ''
      }&search=${searchKey}`
    );

  filteredUserListCount = async (searchKey) => this.httpService.get(`/admin/users/count?&search=${searchKey}`);
  usersOfRolePrev = async (listQuery) =>
    this.httpService.get(
      `/data-adjustments/users-of-role-and-privilege?&page=${listQuery.page}&size=${listQuery.size}${
        (listQuery.sortField && '&sort=' + listQuery.sortField) || ''
      }&searchText=${listQuery.filterValues.searchText}&role=${
        (listQuery.filterValues.role && listQuery.filterValues.role) || ''
      }&privilege=${(listQuery.filterValues.privilege && listQuery.filterValues.privilege) || ''}`
    );

  activeDeactiveUser = async (userStatus, id) => await this.httpService.put(`/admin/users/${id}/active`, userStatus);

  resetUserPassword = async (email) => await this.httpService.postForm(`/account/request-reset-password/admin-users`, email);

  deleteUser = async (id) => this.httpService.delete(`/admin/users/${id}`);

  addUser = async (formData) => this.httpService.post(`/admin/users`, formData);

  checkEmailAvailability = async (email) => this.httpService.post(`/admin/users/email-available`, { email: email });

  updateUser = async (formData, id) => this.httpService.put(`/admin/users/${id}`, formData);

  resetPasswordVerification = async (formData) => this.httpService.postForm(`/account/verify-password-reset/admin-users`, formData);

  changePassword = async (formData) => this.httpService.postForm(`/account/reset-password/admin-users`, formData);
}

@Injectable()
export class AdminUsersService {
  constructor(protected http: AdminUsersHttp) {}

  async loadUsers() {
    return await this.http.loadUsers();
  }
  getRoleWiseUsers = async (searchParams) => {
    return await this.http.getRoleWiseUsers(searchParams);
  };
  async filteredUserList(searchKey, listQuery) {
    return await this.http.filteredUserList(searchKey, listQuery);
  }
  async filteredUserListCount(searchKey) {
    return await this.http.filteredUserListCount(searchKey);
  }
  async usersOfRolePrev(listQuery) {
    return await this.http.usersOfRolePrev(listQuery);
  }
  async activeDeactiveUser(userStatus, id) {
    return await this.http.activeDeactiveUser(userStatus, id);
  }
  async resetUserPassword(email) {
    return await this.http.resetUserPassword(email);
  }

  async resetPasswordVerification(formData) {
    return await this.http.resetPasswordVerification(formData);
  }

  async changePassword(formData) {
    return await this.http.changePassword(formData);
  }

  addUser = async (values) => this.http.addUser(values);

  deleteUser = async (id) => this.http.deleteUser(id);

  checkEmailAvailability = async (email) => this.http.checkEmailAvailability(email);

  async updateUser(values, id) {
    return await this.http.updateUser(values, id);
  }
}
